// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZK-w7","header":"styles_header__ji+hT","content":"styles_content__DHCOj"};